module.exports = __webpack_public_path__ + "static/img/02003C_2_C_20230710_LC.3176254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02003C_2_C_20230710_LC.png
// module id = UnVQ
// module chunks = 0